import { palette } from 'theme/tokens';
import { SHOW_API_STATUS_BADGE } from 'flagSwitch/SwitchConfig';
/**
 * QA-only status dot shown on sidebar nav items in BOTH portals.
 *
 * A nav entry carries `apiStatus: 'verified' | 'in_progress'`:
 *   in_progress (yellow) — the screen's APIs are wired, awaiting QA sign-off
 *   verified    (green)  — QA has confirmed the APIs work end to end
 *
 * Admin renders it with a MUI <Badge> (admin/components/layout/SidebarNavItem.jsx);
 * the partner sidebar is hand-rolled and draws its own dot (partner/components/
 * layout/AppLayout.jsx). The colours live here and the switch is read here so
 * the portals cannot drift — SHOW_API_STATUS_BADGE (flagSwitch/SwitchConfig)
 * off hides both.
 */

export const API_STATUS_COLORS = { verified: palette.custom.green[480], in_progress: palette.custom.amber[470] };

/** The dot colour for a nav item, or undefined when nothing should render. */
export const apiStatusColor = (status) =>
  SHOW_API_STATUS_BADGE === true ? API_STATUS_COLORS[status] : undefined;
